import i18n from '@/plugins/i18n'
import { api } from '@/util/api'
import { authsHandler } from '@/util/btnAuths'

export const localeList = {
  // 'en-US': 'En',
  'zh-TW': '繁中',
  'zh-CN': '簡中',
}

// 帳號類型
export const registerTypeList = [
  { label: i18n.global.t('registerType_mail'), value: 'mail' },
  { label: i18n.global.t('registerType_phone'), value: 'phone' },
  {
    label: i18n.global.t('registerType_apple.com'),
    value: 'thirdPart-apple.com',
  },
  {
    label: i18n.global.t('registerType_google.com'),
    value: 'thirdPart-google.com',
  },
  {
    label: i18n.global.t('registerType_oidc.line'),
    value: 'thirdPart-oidc.line',
  },
]

// 是否已讀
export const isReadList = [
  { label: i18n.global.t('isRead_read'), value: true },
  { label: i18n.global.t('isRead_unread'), value: false },
]

// 是否啟用
export const isEnableList = [
  { label: i18n.global.t('yes'), value: 'enable' },
  { label: i18n.global.t('no'), value: 'disable' },
]

// 是否啟用
export const onOffList = [
  { label: 'Off', value: false },
  { label: 'On', value: true },
]

// 開關狀態
export const enableStatusList = [
  { label: i18n.global.t('enable'), value: 'enable' },
  { label: i18n.global.t('disable'), value: 'disable' },
]

// // 幣種
// export const currencyTypeList = async (type = 'all') => {
//   try {
//     const { data } = await api.get('admin/currency')
//     const locale = sessionStorage.getItem('locale')
//     let result = data.data.map(item => {
//       return {
//         label: item.memo[locale],
//         value: item.name
//       }
//     })
//     if (type === 'game') {
//       result = result.filter(item => ['SYS', 'EXP'].includes(item.value))
//     }
//     return result
//   } catch (err) {
//     console.log('error', err)
//   }
// }
// 幣種
export const currencyTypeList = [
  { label: i18n.global.t('currency_SYS'), value: 'SYS' },
  { label: i18n.global.t('currency_EXP'), value: 'EXP' },
]

// 查詢幣種列表(會根據權限動態查詢幣種)
export const rechargeCurrencyList = async () => {
  try {
    const { data } = await api.get('admin/member/recharge/currency/list')
    return data.data.map((item) => {
      return {
        label: i18n.global.t(`currencyType_${item}`),
        value: item,
      }
    })
  } catch (err) {
    console.log('error', err)
  }
}

// 多發模式
export const businessModeList = [
  { label: i18n.global.t('businessMode_none'), value: 'none' },
  { label: i18n.global.t('businessMode_manual'), value: 'manual' },
  { label: i18n.global.t('businessMode_twice'), value: 'twice' },
  { label: i18n.global.t('businessMode_three'), value: 'three' },
]

// 多發模式(篩選用)
export const businessModeOptionList = [
  { label: 'Off', value: 'none' },
  { label: 'On', value: 'manual,twice,three' },
]

// 保險模式
export const insuranceModeModeList = [
  { label: i18n.global.t('insuranceMode_none'), value: 'none' },
  { label: i18n.global.t('insuranceMode_classic'), value: 'classic' },
  { label: i18n.global.t('insuranceMode_ev'), value: 'ev' },
]

export const currencyList = [
  { label: 'USDT', value: 'USDT' },
  { label: i18n.global.t('EXP'), value: 'EXP' },
]

// 警告類型
export const warningTypeList = [
  { label: i18n.global.t('ipLimit'), value: 'ipLimit' },
  { label: i18n.global.t('gpsUnusual'), value: 'gpsUnusual' },
  { label: i18n.global.t('limitGPS'), value: 'limitGPS' },
  { label: i18n.global.t('videoLimit'), value: 'videoLimit' },
  { label: i18n.global.t('audioLimit'), value: 'audioLimit' },
]

// 充值類別
export const depositTypeList = [
  { label: i18n.global.t('manualRecharge'), value: 'manual' },
  { label: i18n.global.t('customerRecharge'), value: 'customer' },
]

// 訂單狀態
export const orderStatusList = [
  { label: i18n.global.t('success'), value: 'success' },
  { label: i18n.global.t('fail'), value: 'fail' },
  { label: i18n.global.t('pending'), value: 'pending' },
]

// 狀態
export const statusList = [
  { label: i18n.global.t('success'), value: 'success' },
  { label: i18n.global.t('fail'), value: 'fail' },
]

// 公桌狀態
export const publicTableStatusList = [
  { label: i18n.global.t('publicTableStatus_initial'), value: 'initial' },
  { label: i18n.global.t('publicTableStatus_playing'), value: 'playing' },
  { label: i18n.global.t('publicTableStatus_disable'), value: 'disable' },
]

// gameId列表
export const gameIdList = {
  texas: 1,
  short: 2,
  omaha: 3,
  aof: 4,
  'aof-short': 5,
}

// 查詢遊戲類型列表
export const gameTypeList = [
  { label: i18n.global.t('checkAll'), value: null },
  { label: i18n.global.t('gameType_TEXAS'), value: 'TEXAS' },
  { label: i18n.global.t('gameType_AOF'), value: 'AOF' },
  { label: i18n.global.t('gameType_SHORT_DECK'), value: 'SHORT_DECK' },
  { label: i18n.global.t('gameType_OMAHA'), value: 'OMAHA' },
]

// 查詢語言列表
export const languageList = async () => {
  try {
    const { data } = await api.get('/admin/language')
    return data.data.map((item) => {
      return {
        label: item.label,
        value: item.key,
      }
    })
  } catch (err) {
    console.log('error', err)
  }
}

// 代理組管理 -> 查詢新增代理的聚樂部列表
export const getAgentClubAPI = async () => {
  const params = { size: 9999, page: 1 }
  try {
    const { data } = await api.get('/admin/agent/club', params)
    return data.data.pageList.map((item) => {
      return { label: item.clubName, value: item.clubId }
    })
  } catch (err) {
    console.error('getAgentClubAPI', err)
  }
}

export const buyInModeList = [
  { label: i18n.global.t('buyInMode_none'), value: 'none' },
  { label: i18n.global.t('buyInMode_auto'), value: 'auto' },
  { label: i18n.global.t('buyInMode_manual'), value: 'manual' },
]

// 查詢保險列表
export const insuranceModeList = [
  { label: i18n.global.t('insurance_none'), value: 'none' },
  { label: i18n.global.t('insurance_classic'), value: 'classic' },
  // { label: i18n.global.t('insurance_ev'), value: 'ev' }
]

// 查詢瞇牌模式列表
export const squintModeList = [
  { label: i18n.global.t('squintMode_none'), value: 'none' },
  { label: i18n.global.t('squintMode_behind'), value: 'behind' },
  { label: i18n.global.t('squintMode_lead'), value: 'lead' },
  { label: i18n.global.t('squintMode_same'), value: 'same' },
]

// 查詢計算模式
export const pipelineList = [
  { label: i18n.global.t('pipeline_pot'), value: 'pot' },
  { label: i18n.global.t('pipeline_profit'), value: 'profit' },
]

// 查詢角色列表
export const roleList = async () => {
  try {
    const { data } = await api.get('/admin/auth/template/list')
    return data.data.map((item) => {
      return {
        label: item.name,
        value: item.templateId,
      }
    })
  } catch (err) {
    console.log('error', err)
  }
}

// 用戶狀態
export const staffStatusList = [
  { label: i18n.global.t('staffStatus_enable'), value: 'enable' },
  { label: i18n.global.t('staffStatus_disable'), value: 'disable' },
  { label: i18n.global.t('staffStatus_unverified'), value: 'unverified' },
]

// 查詢遊戲列表
export const gameList = async () => {
  try {
    const { data } = await api.get('/admin/game')
    return data.data
  } catch (err) {
    console.log('error', err)
  }
}

// 手服務費模式
export const roundFeeModeList = [
  { label: i18n.global.t('roundFeeMode_none'), value: 'none' },
  { label: i18n.global.t('roundFeeMode_percent'), value: 'percent' },
]

// 服務費配置-固定模式
export const fixModeList = [
  { label: i18n.global.t('fixMode_pot'), value: 'pot' },
]

// 跑馬燈狀態
export const marqueeStatusList = [
  { label: i18n.global.t('marqueeStatus_unpublished'), value: 'unpublished' },
  { label: i18n.global.t('marqueeStatus_published'), value: 'published' },
]

// 競技場賽季狀態
export const arenaStatusList = [
  { label: i18n.global.t('arenaStatus_initial'), value: 'initial' },
  { label: i18n.global.t('arenaStatus_pending'), value: 'pending' },
  { label: i18n.global.t('arenaStatus_playing'), value: 'playing' },
  { label: i18n.global.t('arenaStatus_pause'), value: 'pause' },
  { label: i18n.global.t('arenaStatus_maintain'), value: 'maintain' },
  { label: i18n.global.t('arenaStatus_settling'), value: 'settling' },
  { label: i18n.global.t('arenaStatus_finish'), value: 'finish' },
  { label: i18n.global.t('arenaStatus_disable'), value: 'disable' },
]

// 梯次狀態
export const waveStatusList = [
  { label: i18n.global.t('waveStatus_pending'), value: 'pending' },
  { label: i18n.global.t('waveStatus_delay'), value: 'delay' },
  { label: i18n.global.t('waveStatus_playing'), value: 'playing' },
  { label: i18n.global.t('waveStatus_pause'), value: 'pause' },
  { label: i18n.global.t('waveStatus_finish'), value: 'finish' },
]

// 狀態列表2
export const enableStatusList2 = [
  { label: i18n.global.t('status_enable'), value: 'enable' },
  { label: i18n.global.t('status_disable'), value: 'disable' },
]

// 查詢發佈位置
export const getReleaseLocationAPI = async () => {
  try {
    const { data } = await api.get('admin/banner/releaseLocation')
    return data.data
    // return data.data.map(item => {
    //   return {
    //     label: item,
    //     value: item
    //   }
    // })
  } catch (err) {
    console.log('error', err)
  }
}

// 查詢模板列表
export const getArenaSettingTemplateList = async () => {
  try {
    const { data } = await api.get('/admin/arena/setting/list/templates')
    const locale = sessionStorage.getItem('locale')
    data.templateListInfo = data.data.templateListInfo.map((item) => {
      return {
        label: item.name,
        value: item.id,
      }
    })
    data.tableTemplateInfo = data.data.tableTemplateInfo.map((item) => {
      return {
        label: JSON.parse(item.name)[locale],
        value: item.id,
      }
    })
    data.matchBlindInfo = data.data.matchBlindInfo.map((item) => {
      return {
        label: item.name,
        value: item.id,
      }
    })
    return data
  } catch (err) {
    console.log('error', err)
  }
}

// 查詢獎勵列表
export const getPrizeList = async () => {
  try {
    const { data } = await api.get(`admin/arena/setting/list/prizes`)
    return data.data
  } catch (error) {
    console.log('error', error)
  }
}

// 查詢票券列表
export const getTicketList = async () => {
  try {
    const { data } = await api.get(`admin/arena/tableTemplate/ticket/list`)
    const locale = sessionStorage.getItem('locale')
    return data.data.map((item) => {
      return {
        label: item.name[locale],
        value: item.id,
      }
    })
  } catch (error) {
    console.log('error', error)
  }
}

// 公告子類型
export const announcementSubTypeList = [
  { label: i18n.global.t('announcementSubType_normal'), value: 'normal' },
  {
    label: i18n.global.t('announcementSubType_maintenance'),
    value: 'maintenance',
  },
]

// 取得跑馬燈公告類型
export const getMarqueeTypeList = async () => {
  let list = []
  if (
    authsHandler(
      'information-parent',
      'information-marquee',
      'information-marquee-system'
    )
  ) {
    list.push({
      label: i18n.global.t('announcementSubType_normal'),
      value: 'normal',
    })
  }
  if (
    authsHandler(
      'information-parent',
      'information-marquee',
      'information-marquee-normal'
    )
  ) {
    list.push({
      label: i18n.global.t('announcementSubType_system'),
      value: 'system',
    })
  }
  return list
}

// 信件狀態
export const mailStatusList = [
  { label: i18n.global.t('mailStatus_pending'), value: 'pending' },
  { label: i18n.global.t('mailStatus_success'), value: 'success' },
  { label: i18n.global.t('mailStatus_enable'), value: 'enable' },
  { label: i18n.global.t('mailStatus_disable'), value: 'disable' },
]

// 物品類型
export const itemTypeList = [
  { label: i18n.global.t('itemType_currency'), value: 'currency' },
  { label: i18n.global.t('itemType_item'), value: 'item' },
]

// 查詢附件列表
export const getItemParameterList = async () => {
  try {
    const { data } = await api.get(`admin/mailDetailSetting/info`)
    return data.data
  } catch (error) {
    console.log('error', error)
  }
}

// 查詢模板id
export const getMailDetailIdList = async () => {
  const params = { size: 9999, page: 1 }
  try {
    const { data } = await api.get(`admin/mailDetailSetting/record`, params)
    return data.data.pageList.map((item) => {
      return { label: item.name, value: item.id }
    })
  } catch (error) {
    console.log('error', error)
  }
}

// 寄出時間列表
export const sendTimeList = [
  { label: i18n.global.t('sendTime_manual'), value: 'manual' },
  { label: i18n.global.t('sendTime_specify'), value: 'specify' },
]

// 上架時間列表
export const addedTimeList = [
  { label: i18n.global.t('addedTime_manual'), value: 'manual' },
  { label: i18n.global.t('addedTime_specify'), value: 'specify' },
]

// 寄件對象列表
export const receiverTypeList = [
  { label: i18n.global.t('receiverType_current'), value: 'current' },
  { label: i18n.global.t('receiverType_new'), value: 'new' },
  { label: i18n.global.t('receiverType_uid'), value: 'uid' },
]

// 查詢跑馬燈列表
export const getMarqueeList = async () => {
  try {
    const { data } = await api.get(`admin/maintenance/marquee/list`)
    const locale = sessionStorage.getItem('locale')
    return data.data.map((item) => {
      return {
        label: item.content[locale],
        value: item.id,
      }
    })
  } catch (error) {
    console.log('error', error)
  }
}

// 桌狀態
export const tableStatusList = [
  { label: i18n.global.t('tableStatusSearch_playing'), value: 'playing' },
  { label: i18n.global.t('tableStatusSearch_finish'), value: 'finish' },
]
export const tableStatus2List = [
  { label: i18n.global.t('tableStatus_pending'), value: 'pending' },
  { label: i18n.global.t('tableStatus_playing'), value: 'playing' },
  { label: i18n.global.t('tableStatus_settling'), value: 'settling' },
  { label: i18n.global.t('tableStatus_finish'), value: 'finish' },
  { label: i18n.global.t('tableStatus_cancel'), value: 'cancel' },
]

// 查詢盲注等級列表
export const getBadBeatJackpotLevelList = async () => {
  try {
    const { data } = await api.get(`admin/game/badBeatJackpot/level`)
    return data.data.map((item) => {
      return {
        label: item,
        value: item,
      }
    })
  } catch (error) {
    console.log('error', error)
  }
}

// 代理類型(無會員)
export const agentTypeWithoutMemberList = [
  { label: i18n.global.t('agentType_agent1'), value: 'agent1' },
  { label: i18n.global.t('agentType_agent2'), value: 'agent2' },
  { label: i18n.global.t('agentType_agent3'), value: 'agent3' },
]

// 代理類型
export const agentTypeList = [
  { label: i18n.global.t('agentType_agent1'), value: 'agent1' },
  { label: i18n.global.t('agentType_agent2'), value: 'agent2' },
  { label: i18n.global.t('agentType_agent3'), value: 'agent3' },
  { label: i18n.global.t('agentType_member'), value: 'member' },
]

// 代理狀態
export const agentStatusList = [
  { label: i18n.global.t('agentStatus_enable'), value: 'enable' },
  { label: i18n.global.t('agentStatus_deleted'), value: 'deleted' },
  { label: i18n.global.t('agentStatus_disable'), value: 'disable' },
]

// 消費紀錄
export const isConsumeList = [
  { label: i18n.global.t('isConsume_true'), value: 'true' },
  { label: i18n.global.t('isConsume_false'), value: 'false' },
]

// 第三方平台列表
export const platformList = [
  { label: i18n.global.t('platform_google'), value: 'google' },
  { label: i18n.global.t('platform_apple'), value: 'apple' },
]

// 內購紀錄狀態
export const iapStatusList = [
  { label: i18n.global.t('iapStatus_pending'), value: 'pending' },
  { label: i18n.global.t('iapStatus_success'), value: 'success' },
  { label: i18n.global.t('iapStatus_cancel'), value: 'cancel' },
]

// 商品購買紀錄狀態
export const shopStatusList = [
  { label: i18n.global.t('shopStatus_personal'), value: 'personal' },
  { label: i18n.global.t('shopStatus_giveGift'), value: 'giveGift' },
]

// 交易類型
export const tradeTypeList = [
  { label: i18n.global.t('tradeType_redEnvRake'), value: 'redEnvRake' },
  {
    label: i18n.global.t('tradeType_redEnvDistribute'),
    value: 'redEnvDistribute',
  },
]

export const tradeTypeBadBeatJackpotList = [
  {
    label: i18n.global.t('tradeTypeBadBeatJackpot_badBeatRake'),
    value: 'badBeatRake',
  },
  {
    label: i18n.global.t('tradeTypeBadBeatJackpot_badBeatDistribute'),
    value: 'badBeatDistribute',
  },
]

// 居住國列表
export const getResidentCountryList = async () => {
  try {
    const { data } = await api.get(`admin/country`)
    return data.data
  } catch (error) {
    console.log('error', error)
  }
}
